<template>
    <div>
        <div>
            <b-form-group
                :label="scipNameLabel"
                label-for="scipName"
            >
                <b-form-input
                    id="scipName"
                    v-model="name"
                    @input="emit"
                />
            </b-form-group>

            <b-form-group
                :label="scipNumberLabel"
                label-for="scipId"
            >
                <b-form-input
                    id="scipId"
                    class="input-bg-warning"
                    v-model="id"
                    :state="idState"
                    @input="emit"
                />
            </b-form-group>
        </div>
        <div
            class="mt-2"
        >
            <ComponentScipInformation
                v-if="isComponentContainerVisible(container)"
                v-for="container in componentContainers"
                :component="container.component"
                :parents="container.parents"
                @validityChanged="(isValid) => componentValidityChanged(container, isValid)"
                @input="onComponentScipInformationChange"
            />
        </div>
    </div>
</template>

<script>
import ReplyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import {getScipId, getScipName, ProductIdentifiers, ProductNames, setNameOrId} from "@/libs/product";
import {BFormInput, BFormGroup} from 'bootstrap-vue'
import {ProductProvider} from "@core/domain/product";
import ComponentScipInformation
    from "@/views/request/received/flow/components/vertiacal-steps/ComponentScipInformation";
import backendResponse from "@core/mixins/ui/backend-response";
import {ViolationCode} from "@core/api";

export default {
    mixins: [ReplyTabProductSection, backendResponse],
    components: {BFormInput, BFormGroup, ComponentScipInformation},
    props: {
        product: {
            required: true,
        },
        componentContainers: {
            required: true
        }
    },
    data() {
        return {
            name: getScipName(this.product),
            id: getScipId(this.product),
            timeouts: {},
            validityTimeout: null,
            componentsValidityState: {}
        };
    },
    methods: {
        emit() {
            this.$emit('input', {
                name: this.name,
                id: this.id
            });

            this.emitValidity();
        },

        onComponentScipInformationChange(component, information, beforeRequestCallback, afterRequestCallback) {
            clearTimeout(this.timeouts[component.id]);

            this.timeouts[component.id] = setTimeout(() => {
                const product = ProductProvider(component.id);
                beforeRequestCallback();
                product
                    .getCard()
                    .then((card) => {
                        setNameOrId(card.names, ProductNames.SCIP_NAME, information.name);
                        setNameOrId(card.identifiers, ProductIdentifiers.SCIP_NUMBER, information.id);

                        product
                            .saveCard()
                            .then(() => {
                                component.scipInformation.name = information.name;
                                component.scipInformation.id = information.id;
                                this.emitScipInformationChange(component, information);
                                afterRequestCallback();
                            })
                            .catch(e => {
                                this.handleBackendError(e);
                                afterRequestCallback({
                                    id: this.getViolationsWithCodes(e, [
                                        ViolationCode.SCIP_NUMBER_TAKEN
                                    ])
                                });
                            })
                        ;
                    });

                this.emitValidity();
            }, 2500);
        },

        componentValidityChanged(container, isValid) {
            this.componentsValidityState[this.generateComponentReferenceUniqueId(container)] = isValid;

            clearTimeout(this.validityTimeout);
            this.validityTimeout = setTimeout(() => {
                this.emitValidity();
            }, 1000);
        },

        isComponentContainerVisible(container) {
            return container.substances.length > 0 && this.product.id !== container.component.id;
        },

        emitScipInformationChange(component, information) {
            this.$emit('componentScipInformationChange', component, information)
        },

        emitValidity() {
            //  we suppose scip is valid when
            //  - name is set for root product
            //  - name is set for each component
            let states = [];

            //  HAM-492
            // if (!this.name) {
            //     states.push(false);
            // }
            //
            // if (this.componentContainers.length > 0) {
            //     const numberComponentsThatDeclareConcernSubstances = this.componentContainers.filter(container => {
            //         return container.component.hasConcernSubstances === true;
            //     }).length;
            //     if (numberComponentsThatDeclareConcernSubstances !== Object.keys(this.componentsValidityState).length) {
            //         states.push(false);
            //     } else {
            //         states.push(!(Object.values(this.componentsValidityState).includes(false) === true));
            //     }
            // }

            this.$emit('validityChanged', !(states.includes(false) === true));
        },

        generateComponentReferenceUniqueId(container) {
            return 'scipComponent_' + container.parents.map(p => p.id).join('_');
        }
    },
    computed: {
        nameState() {
            return this.name !== undefined && this.name !== '' && this.name.length > 1;
        },
        idState() {
            return null;
        },
    },
    watch: {
        product(p) {
            this.name = getScipName(this.product);
            this.id = getScipId(this.product);

            this.emitValidity();
        }
    }
}
</script>
